/**
 * Who may @-mention the ops bot (Caesar / isAgent users) in CRM comments.
 * Mirrors functions/src/agentAccessModel.ts canMentionOpsBot.
 */

import type { EmployeeDesignation, UserRole } from '../types';

export const OPS_BOT_MENTION_DESIGNATIONS: readonly EmployeeDesignation[] = [
  'coo',
  'cfo',
  'executive_assistant',
  'office_manager',
  'sales_rep',
];

export const OPS_BOT_MENTION_BLOCKED_MESSAGE =
  'Only admins, executives (COO/CFO/EA), office managers, and sales reps can @mention the ops bot.';

export function canMentionOpsBot(input: {
  role?: UserRole | string | null;
  designations?: readonly string[] | null;
}): boolean {
  const role = String(input.role || '').trim().toLowerCase();
  if (role === 'admin') return true;
  const staff =
    role === 'employee'
    || role === 'employee_office'
    || role === 'employee_shop'
    || role === 'staff'
    || role === 'cpa';
  if (!staff) return false;
  const designations = new Set(
    (input.designations || []).map((d) => String(d || '').trim().toLowerCase()).filter(Boolean),
  );
  return OPS_BOT_MENTION_DESIGNATIONS.some((d) => designations.has(d));
}

/** Hide agent/bot users from @ pickers when the viewer is not allow-listed. */
export function filterOpsBotFromMentions<T extends { isAgent?: boolean }>(
  users: T[],
  viewer: { role?: UserRole | string | null; designations?: readonly string[] | null },
): T[] {
  if (canMentionOpsBot(viewer)) return users;
  return users.filter((u) => u.isAgent !== true);
}
